var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlacementLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2496 26.8547L35.4058 44.6172C35.4412 44.8264 35.4118 45.0414 35.3217 45.2334C35.2316 45.4254 35.085 45.5854 34.9015 45.6918C34.718 45.7983 34.5064 45.8462 34.295 45.8291C34.0836 45.8121 33.8824 45.7309 33.7183 45.5964L26.26 39.9985C25.8999 39.7295 25.4626 39.5842 25.0131 39.5842C24.5637 39.5842 24.1263 39.7295 23.7662 39.9985L16.2954 45.5943C16.1315 45.7286 15.9305 45.8096 15.7194 45.8267C15.5082 45.8438 15.2968 45.796 15.1135 45.6899C14.9301 45.5837 14.7835 45.4242 14.6932 45.2325C14.6028 45.0409 14.5731 44.8262 14.6079 44.6172L17.7621 26.8547",
    stroke: "white",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 29.1667C31.9036 29.1667 37.5 23.5702 37.5 16.6667C37.5 9.76313 31.9036 4.16669 25 4.16669C18.0964 4.16669 12.5 9.76313 12.5 16.6667C12.5 23.5702 18.0964 29.1667 25 29.1667Z",
    stroke: "black",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlacementLogo);
export default __webpack_public_path__ + "static/media/placement_logo.5e9bad69a197d92309587a0e63d59fe0.svg";
export { ForwardRef as ReactComponent };